import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsFHEConnect(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsFHEConnect(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsFHEConnect - ', e);
                throw e;
            });
    };
}
export { getLogsFHEConnect };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsFHEConnect/actions.js